import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightShow12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSidebarRightShow12Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 2H1.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H7zm-7 .5A1.5 1.5 0 0 1 1.5 1h9c.456 0 .865.204 1.14.526h.008v.009c.22.26.352.597.352.965v7a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 9.5zm5.339 2.086a.5.5 0 1 0-.707-.707L2.864 5.647 2.51 6l.354.354 1.768 1.768a.5.5 0 1 0 .707-.708L3.925 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightShow12Filled);
